import { Routes } from '@angular/router';
import { MessagesWorkspaceComponent } from './components/messages-workspace.component';

export const messagesRoutes: Routes = [
  {
    path: 'messages-workspace',
    component: MessagesWorkspaceComponent,
    data: {
      permissions: ['ConfigurationModule.Messages:Edit']
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/messages/routes.config.ts